// Angular
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// RCCL
import { RclExcaliburModule } from '@rccl/rcl-excalibur';

// OLCI
import { CoreModule } from '../core/core.module';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { LandingBackContainerComponent } from './landing-page-container/landing-page.container';
import { GuestSelectionForCheckinComponent } from './guest-selection-for-checkin/guest-selection-for-checkin.component';

@NgModule({
	imports: [CoreModule, CommonModule, RclExcaliburModule],
	declarations: [GuestSelectionForCheckinComponent, LandingPageComponent, LandingBackContainerComponent],
	providers: [],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class LandingPageModule {}
